import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PriceTicker from "@/components/PriceTicker";
import AdMarquee from "@/components/AdMarquee";
import WhatsAppButton from "@/components/WhatsAppButton";
import WelcomePopup from "@/components/WelcomePopup";

export default function Layout({ children }) {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");
    return (
        <div className="min-h-screen flex flex-col bg-white" data-testid="layout-root">
            <PriceTicker />
            <AdMarquee />
            <Header />
            <AdMarquee
                endpoint="/codes-strip"
                title="أكواد خصم"
                data_testid_prefix="codes-strip"
            />
            <main className="flex-1">{children}</main>
            <Footer />
            {!isAdmin && <WhatsAppButton />}
            {!isAdmin && <WelcomePopup />}
        </div>
    );
}
